export const FACEBOOK_APP_ID = 1624118454533304

export const GROUP_STATUS = {
  CLOSED: 'CLOSED',
  ACTIVE: 'ACTIVE',
}

export const userType = {
  CREATOR: 'CREATOR',
  CONTRIBUTOR: 'CONTRIBUTOR',
}

export enum GroupType {
  CREATED,
  CONTRIBUTED,
}

export const ALLOWED_IMAGE_TYPES: { [key: string]: string[] } = {
  'image/png': ['.png'],
  'image/jpg': ['.jpg', '.jpeg'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/gif': ['.gif'],
}

export const UNALLOWED_ENCODED_IMAGE_TYPES = [
  '52494646', // Webp
  '57454250', // Webp
]

export const COVER_IMAGE_MAX_TOTAL_SIZE = 1600

export const COVER_IMAGE_DEFAULT_IMAGE_URL =
  'https://www.paypalobjects.com/groups/background/default-background.jpg'

// Cover image alternate URLs where were previously in use
export const COVER_IMAGE_ALTERNATE_DEFAULT_IMAGE_URLS = [
  'https://www.paypalobjects.com/groups/default-background.png',
  'https://www.paypalobjects.com/groups/default-background2x.png',
]

export const HEADER_TYPES = {
  SIGNEDIN: 'SIGNEDIN',
  GUEST: 'GUEST',
}

export const ELIGIBILITY_STATES = {
  ELIGIBLE: 'ELIGIBLE',
  INELIGIBLE: 'INELIGIBLE',
}

export const HOME_PATH = '/pool'

export const REGEX = {
  // Mirrors backend @pattern: letters, marks, numbers, punctuation, currency, math, modifier symbols, whitespace
  ALLOWED_CHARACTERS: /^[\p{L}\p{M}\p{N}\p{P}\p{Sc}\p{Sm}\p{Sk}\s]+$/u,
}

export enum LINK_SOURCE {
  COPY = 0,
  NATIVE = 1,
}

export const PAYPAL_OBJECTS_DIRECTORY = 'https://www.paypalobjects.com'

export const COVER_IMAGE_BORDER_RADIUS = '16px'

export const MEDIA_FILES_CATEGORIES = {
  ALL: 'ALL',
  DEFAULT: 'DEFAULT',
  BIRTHDAY: 'BIRTHDAY',
  WEDDING: 'WEDDING',
  TRIP: 'TRIP',
  GENERIC: 'GENERIC',
}

export const SHEET_SOURCE = {
  CREATE_GROUP_BUTTON: 'createButton',
  CONTRIBUTE_GROUP_BUTTON: 'contributeButton',
}

// Re-export error constants
export * from './errors'
